import { render, staticRenderFns } from "./SensitiveDataWrapper.vue?vue&type=template&id=f07d3652&scoped=true&"
import script from "./SensitiveDataWrapper.vue?vue&type=script&lang=js&"
export * from "./SensitiveDataWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SensitiveDataWrapper.vue?vue&type=style&index=0&id=f07d3652&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07d3652",
  null
  
)

export default component.exports